import { FC, type JSX } from 'react';
import { getTripHistoryModeConfig } from './trip-history-base-controller';
import { TripHistoryDesktopViewController } from './trip-history-desktop-view-controller';

export const TripHistoryMobileViewController: FC = (): JSX.Element => {
  const modeConfig = getTripHistoryModeConfig('mobile');
  return <TripHistoryDesktopViewController autoSelectFirstTrip={modeConfig.autoSelectFirstTrip} mobileLayout={modeConfig.mobileLayout} />;
};
